import React from "react";
import { Phone, Users } from "lucide-react";

interface FinalCTABlockProps {
  /** Anchor the closing CTA scrolls to. */
  formSectionId: string;
}

const FinalCTABlock: React.FC<FinalCTABlockProps> = ({ formSectionId }) => (
  <section className="bg-mist pb-24 pt-12 dark:bg-slate-950" id="cta">
    <div className="mx-auto max-w-7xl px-6">
      <div className="relative overflow-hidden rounded-[1.75rem] bg-gradient-to-br from-[#0A0226] via-secondary to-[#6B0A2E] px-7 py-20 text-center shadow-2xl md:px-12">
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 bg-[radial-gradient(50%_60%_at_50%_10%,rgba(178,0,48,.35),transparent_65%),radial-gradient(40%_50%_at_100%_100%,rgba(178,0,48,.20),transparent_60%)]"
        />

        <div className="relative z-10">
          <Users
            aria-hidden="true"
            className="mx-auto mb-7 h-14 w-14 text-white/75"
            strokeWidth={1.8}
          />

          <h2 className="text-3xl font-bold leading-tight tracking-tight text-white md:text-5xl">
            See Every Call. Coach Every Rep.
          </h2>

          <p className="mx-auto mt-5 max-w-xl text-lg font-light leading-relaxed text-white/80">
            Schedule a personalized walkthrough and see how FieldCoach turns
            every conversation into coachable, measurable performance for your
            team.
          </p>

          <a
            className="mt-10 inline-flex items-center gap-3 rounded-xl bg-white px-8 py-4 text-base font-bold tracking-tight text-primary shadow-2xl transition-all duration-200 hover:-translate-y-0.5"
            href={`#${formSectionId}`}
          >
            <Phone className="h-5 w-5" />
            Get Started with FieldCoach
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default FinalCTABlock;
